/* ============================================================
   AGILITE QR TOKEN CODEC  (v1)
   ------------------------------------------------------------
   A QR token is the compact, URL-safe payload printed into each
   product tag's URL:  https://agilitegear.com/pages/signup?t=<token>

   This client codec DECODES a token so the landing page can show
   the scanned product. The SERVER re-verifies an HMAC signature
   (added server-side at capture) — the client never trusts the
   token for anything but rendering.

   ONE codec serves both models, so the serialize decision does NOT
   block the build:
     - per-SKU (today)      -> serial = null
     - per-unit (later)     -> serial = "<unique>"  + region/channel/batch fill in

   Fields:
     v        schema version
     sku      REQUIRED — canonical Agilite variant SKU, e.g. "8033MTC1SZ"
     serial   reserved — per-unit serial (enables per-unit dedup + dealer/shipment provenance)
     region   reserved — destined market: ROW | EU | IL (null unless printed per-market)
     channel  reserved — B2C | DEALER
     batch    reserved — print / allocation batch id
   ============================================================ */
(function (global) {
  'use strict';

  var SCHEMA_VERSION = 1;

  // Field order is fixed so encoded tokens are stable/diffable.
  var FIELD_DEFAULTS = {
    v: SCHEMA_VERSION,
    sku: null,      // REQUIRED
    serial: null,   // reserved: per-unit
    region: null,   // reserved: ROW | EU | IL
    channel: null,  // reserved: B2C | DEALER
    batch: null     // reserved: print/allocation batch
  };

  // --- UTF-8-safe base64url ---------------------------------------
  function b64urlEncode(str) {
    var b64 = btoa(unescape(encodeURIComponent(str)));
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64urlDecode(token) {
    var b64 = token.replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    return decodeURIComponent(escape(atob(b64)));
  }

  function normalize(obj) {
    var out = {};
    Object.keys(FIELD_DEFAULTS).forEach(function (k) {
      out[k] = (obj[k] !== undefined && obj[k] !== '') ? obj[k] : FIELD_DEFAULTS[k];
    });
    return out;
  }

  function encode(payload) {
    if (!payload || !payload.sku) throw new Error('AGBQRToken.encode: sku is required');
    return b64urlEncode(JSON.stringify(normalize(payload)));
  }

  // Returns { v, sku, serial, region, channel, batch, _legacy, _raw? }
  function decode(token) {
    if (!token) return null;
    try {
      var s = b64urlDecode(token);
      if (s.charAt(0) === '{') {
        var obj = JSON.parse(s);
        if (obj && obj.sku) {
          var out = normalize(obj);
          out._legacy = false;
          return out;
        }
      }
    } catch (e) { /* fall through to legacy */ }

    // The original brief's bare form (e.g. ?8252medrng) was NOT a real SKU format,
    // so it cannot be reconstructed to a canonical SKU. Flag it: the page still
    // captures the email, tagged source='qr-legacy'.
    var legacy = normalize({ v: 0 });
    legacy._legacy = true;
    legacy._raw = token;
    return legacy;
  }

  global.AGBQRToken = { encode: encode, decode: decode, SCHEMA_VERSION: SCHEMA_VERSION };

})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : this));
